import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { closeModal } from '@/helpers/closeModal';
import { commonChangeMediaProcess, clearImageTimer } from '@/helpers/mediaUtils';
import { updateCtaButtonAction } from '@/modules/actions/mobile/updateCtaButtonAction';
import { animateCurrentProgressBar } from '@/modules/actions/headerLineDuration';
import { getSwiperInstance } from '@/helpers/swiperInstance';
import { mobileAutoPlayNextAction } from '@/modules/actions/mobile/mobileAutoPlayNextAction';
import { checkVolumeButtonState } from "@/helpers/volumeControl";
import pauseImg from '@/assets/images/pause-fill.svg';
import { removeStoreeeOverlay } from "@/helpers/removeOverlay";

export const changeMovieTapAction = () => {
  const wrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .slide-media-wrapper');
  wrappers.forEach((wrapper) => {
    wrapper.addEventListener('click', (e) => {
      moviePlayerController(e.clientX, wrapper);
    });
  });

  function moviePlayerController(clickX, wrapper) {
    const movieWidth = wrapper.clientWidth;
    const swiper = getSwiperInstance();

    // すぐにCTAボタンを非表示にする(チラつき防止)
    const ctaButton = wrapper.querySelector('.ctaFrame');
    ctaButton.style.visibility = 'hidden';

    // 画像タイマーのクリア
    clearImageTimer();

    if (clickX > movieWidth / 2) {
      // 次の動画を再生
      window.moviePosition += 1;
      const contents = navigateMediaItem();
      if (!contents) {
        const overlay = document.querySelector('.storeee_overlay');
        if (overlay) overlay.remove();
        const overlayStyle = document.querySelector('style[data-storeee-overlay]');
        if (overlayStyle) overlayStyle.remove();
        return closeModal();
      }
      if (window.moviePosition != 0) {
        commonChangeMediaProcess(contents);
      } else {
        swiper.slideNext();
      }
    } else {
      // 前の動画を再生
      window.moviePosition -= 1;
      const tmpInt = window.moviePosition;
      const contents = navigateMediaItem();

      if (!contents) {
        // モーダルが閉じた時にオーバーレイも消えるように追加
        removeStoreeeOverlay();
        return closeModal();
      }

      if (tmpInt == -1) {
        // 最初の動画に戻った場合
        swiper.slidePrev();
      } else {
        commonChangeMediaProcess(contents);
      }
    }

    // 再生ボタンの状態を必ず停止ボタンにする
    const playButton = document.querySelector('.storeeel-menu-area-icons #start-desktop');
    if (playButton) {
      playButton.src = pauseImg;
      playButton.alt = 'pause';
      playButton.id = 'pause-desktop';
    }

    // 自動再生の設定
    mobileAutoPlayNextAction();

    // 音量ボタンの状態に応じて動画のミュート変更
    checkVolumeButtonState();

    // 進捗バーのためのインデックスを計算
    let groupIndex = window.storeeelItems.contentGroups.findIndex(group => group.id === window.iconId);
    let progressIndex = 0;
    if (groupIndex == 0) {
      progressIndex = window.moviePosition;
    } else {
      for (let i = 0; i < groupIndex; i++) {
        progressIndex += window.storeeelItems.contentGroups[i].contents.length;
      }
      progressIndex += window.moviePosition;
    }
    // 進捗バーのアニメーションを開始
    const video = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video');
    if (video && video.style.display !== 'none') {
      // 既存のloadedmetadataハンドラがあれば解除
      if (video._onLoadedMetadataForProgress) {
        video.removeEventListener('loadedmetadata', video._onLoadedMetadataForProgress);
        video._onLoadedMetadataForProgress = null;
      }
      // 今回クリック用の一度きりのハンドラを登録
      const onLoaded = () => {
        animateCurrentProgressBar(video.duration, progressIndex);
        // 実行後に念のため自分を解除
        if (video._onLoadedMetadataForProgress) {
          video.removeEventListener('loadedmetadata', video._onLoadedMetadataForProgress);
          video._onLoadedMetadataForProgress = null;
        }
      };
      video._onLoadedMetadataForProgress = onLoaded;
      video.addEventListener('loadedmetadata', onLoaded, { once: true });
    } else {
      const image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper img');
      if (image) {
        animateCurrentProgressBar(5, progressIndex);
      }
    }

    // CTAボタンの更新
    updateCtaButtonAction(wrapper)
  }

  window.addEventListener('storeeel-custom-tap', (e) => {
    const { x, wrapper } = e.detail;
    moviePlayerController(x, wrapper);
  });
}
